/* eslint-disable */
import Vue from 'vue';
import {tentacles} from '@/config/tentacles';
import tentacleServices from '@/services/TentacleServices';
import sensorServices from '@/services/SensorServices';
import languages from '@/config/languages';
import batchServices from '@/services/BatchServices';
import measurementServices from '@/services/MeasurementServices';
import eventServices from '@/services/EventServices';
import userServices from '@/services/UserServices';

export default {
    namespaced: true,
    state: {
        timeFormat: false,  // false = 24h, true = am/pm
        nameFormat: false,  // false = Generic Name, true = Custom Name
        network: false,  // false = Generic Name, true = Custom Name
        units: [],
        loading: false,
        tentacles: [],
        sigfoxCoverage: {},
        heliumCoverage: {},
        type: {},
        user: {
            username: '',
            email: '',
            is_dealer: false,
            is_expert: false,
            token: '',
            refresh_token: '',
            lang: {
                id: 1,
                name: 'EN'
            },
        },
    },
    mutations: {
        SET_TIME_FORMAT(state, newFormat) {
            window.localStorage.setItem('tentacles-time-format', newFormat.toString());
            state.timeFormat = newFormat;
        },
        SET_NAME_FORMAT(state, newFormat) {
            window.localStorage.setItem('tentacles-name-format', newFormat.toString());
            state.nameFormat = newFormat;
        },
        SET_NETWORK(state, newNetwork) {
            window.localStorage.setItem('tentacles-network', newNetwork);
            state.network = newNetwork;
        },
        SET_LOADING(state, loading) {
            state.loading = loading;
        },
        SET_TENTACLES(state, units) {
            state.units = units;
        },
        SET_TYPE(state, type) {
            state.type = type;
        },
        UPDATE_TENTACLE(state, data) {
            data.forEach(updatedUnit => {
                state.units.map(oldUnit => {
                    if (updatedUnit.id === oldUnit.id) {
                        Object.keys(updatedUnit).forEach(key => {
                            if (key === 'sensors') {
                                updatedUnit[key].forEach(sensor => {
                                    oldUnit.sensors.map(oldSensor => {
                                        if (sensor.id === oldSensor.id) {
                                            Object.keys(sensor).forEach(skey => {
                                                if (sensor[skey] !== null) {
                                                    oldSensor[skey] = sensor[skey];
                                                }
                                            })
                                        }
                                    })
                                })
                            } else if (key === 'properties') {
                                if (updatedUnit[key] !== null) {
                                    oldUnit[key] = JSON.parse(updatedUnit[key]);
                                }
                            } else {
                                if (updatedUnit[key] !== null) {
                                    oldUnit[key] = updatedUnit[key];
                                }
                            }
                        })
                    }
                })
            });
        },
        UPDATE_SENSORS(state, data) {
            data.forEach(newSensor => {
                state.units.map(oldUnit => {
                    oldUnit.sensors.forEach(oldSensor => {
                        if (oldSensor.id === newSensor.id) {
                            if (newSensor.minCrit !== null)
                                oldSensor.minCrit = newSensor.minCrit;
                            if (newSensor.maxCrit !== null)
                                oldSensor.maxCrit = newSensor.maxCrit;
                            if (newSensor.minAttention !== null)
                                oldSensor.minAttention = newSensor.minAttention;
                            if (newSensor.maxAttention !== null)
                                oldSensor.maxAttention = newSensor.maxAttention;
                        }
                    })
                })
            })
        },
        SET_USER(state, user) {
            window.localStorage.setItem('tentacles', JSON.stringify(user));
            state.user = user;
        },
        SET_TENTACLE_TYPES(state, data) {
            state.tentacles = tentacles.reduce((accumulator, current) => {
                data.forEach((item) => {
                    if (item.id === current.id) {
                        if (item.default) {
                            state.type = current;
                        }
                        accumulator.push(current);
                    }
                });
                return accumulator;
            }, []);
        },
        SET_SIGFOX_COVERAGE(state, data) {
            state.sigfoxCoverage = data;
        },
        SET_HELIUM_COVERAGE(state, data) {
            state.heliumCoverage = data;
        },
    },
    actions: {
        setLang({commit, dispatch, state}, newLang) {
            return userServices.setLang(JSON.stringify(newLang)).then(response => {
                if (response.status === 200) {
                    let lang = languages.find(item => item.name.toLowerCase() === newLang.lang.toLowerCase());
                    state.user.lang = lang;
                    commit('SET_USER', state.user);
                }
            }).catch(error => {
                return error;
            });
        },
        setTimeFormat({commit, dispatch}, newFormat) {
          commit('SET_TIME_FORMAT', newFormat);
        },
        setNameFormat({commit, dispatch}, newFormat) {
          commit('SET_NAME_FORMAT', newFormat);
        },
        setNetwork({commit, dispatch}, newNetwork) {
          commit('SET_NETWORK', newNetwork);
        },
        checkCoverage({commit, dispatch}, params) {
            commit('SET_LOADING', true);
            return tentacleServices.checkCoverage(params.lat, params.lng, params.radius).then(response => {
                if (response.status === 200) {
                    if (typeof response.data.sigfox !== 'undefined' && response.data.sigfox.locationCovered === true) {
                        commit('SET_SIGFOX_COVERAGE', response.data.sigfox.margins);
                    } else {
                        commit('SET_SIGFOX_COVERAGE', {});
                    }
                    if (response.data.helium.length > 0) {
                        commit('SET_HELIUM_COVERAGE', response.data.helium);
                    } else {
                        commit('SET_HELIUM_COVERAGE', {});
                    }
                    commit('SET_LOADING', false);
                } else {
                    commit('SET_SIGFOX_COVERAGE', {});
                    commit('SET_HELIUM_COVERAGE', {});
                    commit('SET_LOADING', false);
                }
            }).catch(error => {
                // console.log('Error', error);
                return error;
            });
        },
        setTentacles({commit, dispatch}, customerId) {
            commit('SET_LOADING', true);
            return tentacleServices.getTentacleTypes(customerId).then(response => {
                if (response.status === 200) {
                    commit('SET_TENTACLE_TYPES', response.data);
                    commit('SET_TENTACLES', []);
                    commit('SET_LOADING', false);
                }
            }).catch(error => {
                // console.log('Error', error);
                return error;
            });
        },
        setType({commit, dispatch}, params) {
            commit('SET_LOADING', true);
            return tentacleServices.getTentacleByType(params.type.id, params.customer.id).then(response => {
                if (response.status === 200) {
                    commit('SET_TYPE', params.type);
                    commit('SET_TENTACLES', response.data);
                } else if (response.status === 403) {
                    Vue.prototype.$flashStorage.flash(`Error: ${response.data.error}`, 'error');
                }
                commit('SET_LOADING', false);
                return response;
            }).catch(error => {
                // console.log('Error', error);
                return error;
            });
        },
        setUnitByID({commit, dispatch}, id) {
            commit('SET_LOADING', true);
            return tentacleServices.getTentacleByID(id).then(response => {
                if (response.status === 200) {
                    commit('SET_TENTACLES', [response.data]);
                } else if (response.status === 403) {
                    Vue.prototype.$flashStorage.flash(`Error: ${response.data.error}`, 'error');
                }
                commit('SET_LOADING', false);
                return response;
            }).catch(error => {
                // console.log('Error', error);
                return error;
            });
        },
        updateUnit({commit, dispatch}, newTentacles) {
            commit('SET_LOADING', true);
            return tentacleServices.updateTentacles(JSON.stringify(newTentacles)).then(response => {
                if (response.status === 200) {
                    commit('UPDATE_TENTACLE', newTentacles);
                } else if (response.status === 403) {
                    Vue.prototype.$flashStorage.flash(`Error: ${response.data.error}`, 'error');
                }
                commit('SET_LOADING', false);
                return response;
            }).catch(error => {
                // console.log('Error', error);
                return error;
            });
        },
        updateSensors({commit, dispatch}, newSensors) {
            commit('SET_LOADING', true);
            return sensorServices.updateSensor(JSON.stringify(newSensors)).then(response => {
                if (response.status === 200) {
                    commit('UPDATE_SENSORS', newSensors);
                } else if (response.status === 403) {
                    Vue.prototype.$flashStorage.flash(`Error: ${response.data.error}`, 'error');
                }
                commit('SET_LOADING', false);
                return response;
            }).catch(error => {
                // console.log('Error', error);
                return error;
            });
        },
        calibrateDeviceSensor({commit, dispatch}, sensorIdData) {
            commit('SET_LOADING', true);

            let min, max, sensorId;
            if (typeof sensorIdData === "object") {
                sensorId = sensorIdData.sensorId;
                min = sensorIdData.min || false;
                max = sensorIdData.max || false;
            } else {
                min = false;
                max = false;
                sensorId = sensorIdData;
            }

            let body = {'id': sensorId};
            if (min) {
                body.only_min = 1;
            } else {
                body.only_min = 0;
            }

            if (max) {
                body.only_max = 1;
            } else {
                body.only_max = 0;
            }

            return sensorServices.calibrateDevice(JSON.stringify(body)).then(response => {
                if (response.status === 200) {
                } else if (response.status === 403) {
                    Vue.prototype.$flashStorage.flash(`Error: ${response.data.error}`, 'error');
                }
                commit('SET_LOADING', false);
                return response;
            }).catch(error => {
                // console.log('Error', error);
                return error;
            });
        },
        calibrateBatchBySensor({commit, dispatch}, body) {
            commit('SET_LOADING', true);

            return sensorServices.calibrateBatchBySensor(JSON.stringify(body)).then(response => {
                if (response.status === 200) {
                } else if (response.status === 403) {
                    Vue.prototype.$flashStorage.flash(`Error: ${response.data.error}`, 'error');
                }
                commit('SET_LOADING', false);
                return response;
            }).catch(error => {
                // console.log('Error', error);
                return error;
            });
        },
        addCalibrationValueToSensor({commit, dispatch}, sensorIdData) {
            let id = sensorIdData.id;
            let data = {
                raw: sensorIdData.raw,
                percentage: sensorIdData.percentage,
            }
            commit('SET_LOADING', true);
            return sensorServices.addCalibrationValue(id, JSON.stringify(data)).then(response => {
                if (response.status === 200) {
                } else if (response.status === 403) {
                    Vue.prototype.$flashStorage.flash(`Error: ${response.data.error}`, 'error');
                }
                commit('SET_LOADING', false);
                return response;
            }).catch(error => {
                // console.log('Error', error);
                return error;
            });
        },

        removeCalibrationValueFromSensor({commit, dispatch}, sensorIdData) {
            let sensorId = sensorIdData.sensorId;
            let calibrationId = sensorIdData.calibrationId;

            commit('SET_LOADING', true);
            return sensorServices.removeCalibrationValue(sensorId, calibrationId).then(response => {
                if (response.status === 200) {
                } else if (response.status === 403) {
                    Vue.prototype.$flashStorage.flash(`Error: ${response.data.error}`, 'error');
                }
                commit('SET_LOADING', false);
                return response;
            }).catch(error => {
                // console.log('Error', error);
                return error;
            });
        },
        addCalibrationValueToBatch({commit, dispatch}, sensorIdData) {
            let id = sensorIdData.id;
            let data = {
                raw: sensorIdData.raw,
                percentage: sensorIdData.percentage,
            }
            commit('SET_LOADING', true);
            return sensorServices.addCalibrationValueForBatch(id, JSON.stringify(data)).then(response => {
                if (response.status === 200) {
                } else if (response.status === 403) {
                    Vue.prototype.$flashStorage.flash(`Error: ${response.data.error}`, 'error');
                }
                commit('SET_LOADING', false);
                return response;
            }).catch(error => {
                // console.log('Error', error);
                return error;
            });
        },

        removeCalibrationValueFromBatch({commit, dispatch}, sensorIdData) {
            let sensorId = sensorIdData.sensorId;
            let calibrationId = sensorIdData.calibrationId;

            commit('SET_LOADING', true);
            return sensorServices.removeCalibrationValueFromBatch(sensorId, calibrationId).then(response => {
                if (response.status === 200) {
                } else if (response.status === 403) {
                    Vue.prototype.$flashStorage.flash(`Error: ${response.data.error}`, 'error');
                }
                commit('SET_LOADING', false);
                return response;
            }).catch(error => {
                // console.log('Error', error);
                return error;
            });
        },
        setBulkMeasurement({commit, dispatch}, data) {
            let filter = data.filter;
            let tentacle = data.tentacle;
            return measurementServices.getMeasurements(tentacle, JSON.stringify(filter)).then(response => {
                return response;
            }).catch(error => {
                return error;
            });
        },
        setDetailMeasurement({commit, dispatch}, data) {
            let filter = data.filter;
            let tentacle = data.tentacle;
            return measurementServices.getDetailMeasurements(tentacle, JSON.stringify(filter)).then(response => {
                return response;
            }).catch(error => {
                return error;
            });
        },
        setEvent({commit, dispatch}, data) {
            let filter = data.filter;
            let tentacle = data.tentacle;
            return eventServices.getEvents(tentacle, JSON.stringify(filter)).then(response => {
                return response;
            }).catch(error => {
                // console.log('Error', error);
                return error;
            });
        },
        setLogin({commit, dispatch}, data) {
            return userServices.loginUser(data).then(response => {
                if (response.status === 200) {
                    let base64Url = response.data.token.split('.')[1];
                    let base64 = base64Url.replace('-', '+').replace('_', '/');
                    let tokenData = JSON.parse(window.atob(base64));

                    let lang = languages.find(item => item.name.toLowerCase() === tokenData.lang.toLowerCase());
                    const user = {
                        username: data.username,
                        email: 'user@email.com',
                        is_dealer: tokenData.dealer,
                        is_expert: tokenData.isExpert,
                        lang: lang,
                        token: response.data.token,
                        refresh_token: response.data.refresh_token,
                    };
                    commit('SET_USER', user);
                }
                return response;
            });
        },
        setLogout({commit, dispatch}) {
            commit('SET_TENTACLES', []);
            commit('SET_TYPE', []);
            commit('SET_TENTACLE_TYPES', []);
            commit('SET_USER', {username: '', is_dealer: false, is_expert: false, email: '', token: '', refresh_token: '', lang: { id: 1, name: 'EN' }});
            window.localStorage.removeItem('tentacles');
        }
    },
    getters: {
        timeFormat: state => state.timeFormat,
        nameFormat: state => state.nameFormat,
        network: state => state.network,
        loading: state => state.loading,
        type: state => state.type,
        tentacles: state => state.tentacles,
        sigfoxCoverage: state => state.sigfoxCoverage,
        heliumCoverage: state => state.heliumCoverage,
        unitById: state => id => state.units.find(unit => unit.id === id),
        unitBySensor: state => sensorId => {
            return state.units.find(unit => unit.sensors.find(sensor => sensor.id === sensorId));
        },
        units: state => state.units,
        user: state => state.user,
        token: state => state.user.token,
        refreshToken: state => state.user.refresh_token,
        unitsByName: state => name => {
            if (name === '')
                return state.units;

            return state.units.filter(
                item => item.name.toLowerCase().includes(name.toLowerCase()) ||
                item.genericName.toLowerCase().includes(name.toLowerCase()) ||
                item.external.toLowerCase().includes(name.toLowerCase()) ||
                item.lora.deviceEui.toLowerCase().includes(name.toLowerCase()) ||
                (item.remark ? item.remark.toLowerCase().includes(name.toLowerCase()) : false) ||
                (item.customer ? item.customer.toLowerCase().includes(name.toLowerCase()) : false) ||
                item.typeName.toLowerCase().includes(name.toLowerCase())
            )
        },
        unitsSortByString: state => order => {
            if (order.type === 'asc') {
                state.units.sort((a, b) => {
                    if (a[order.key] === null) return 1;
                    if (b[order.key] === null) return -1;
                    var x = a[order.key].toLowerCase();
                    var y = b[order.key].toLowerCase();
                    if (x < y) return -1;
                    else if (x > y) return 1;
                    return 0;
                });
            } else if (order.type === 'desc') {
                state.units.sort((a, b) => {
                    if (a[order.key] === null) return 1;
                    if (b[order.key] === null) return -1;
                    var x = a[order.key].toLowerCase();
                    var y = b[order.key].toLowerCase();
                    if (x > y) return -1;
                    else if (x < y) return 1;
                    return 0;
                });
            }
            return state.units;
        },
        unitsSortByValue: state => order => {
            const myStruct = tentacles.find(tentacle => tentacle.id === state.type.id).sensors; //filter(item => item.label === order.key);
            const label = myStruct.filter(item => item.label === order.key)[0].name;
            const idx = state.units[0].sensors.indexOf(state.units[0].sensors.filter(item => {
                return item.name === label;
            })[0]);

            if (order.type === 'asc') {
                state.units.sort((a, b) => {
                    if (a.sensors[idx].measurement === null) return 1;
                    if (b.sensors[idx].measurement === null) return -1;
                    var x = a.sensors[idx].measurement;
                    var y = b.sensors[idx].measurement;
                    if (x < y) return -1;
                    else if (x > y) return 1;
                    return 0;
                });
            } else if (order.type === 'desc') {
                state.units.sort((a, b) => {
                    if (a.sensors[idx].measurement === null) return 1;
                    if (b.sensors[idx].measurement === null) return -1;
                    var x = a.sensors[idx].measurement;
                    var y = b.sensors[idx].measurement;
                    if (x > y) return -1;
                    else if (x < y) return 1;
                    return 0;
                });
            }
            return state.units;
        },
        unitsSortByDate: state => order => {
            if (order.type === 'asc') {
                state.units.sort((a, b) => {
                    if (a[order.key] === null) return 1;
                    if (b[order.key] === null) return -1;
                    var x = a[order.key];
                    var y = b[order.key];
                    if (x < y) return -1;
                    else if (x > y) return 1;
                    return 0;
                });
            } else if (order.type === 'desc') {
                state.units.sort((a, b) => {
                    if (a[order.key] === null) return 1;
                    if (b[order.key] === null) return -1;
                    var x = a[order.key];
                    var y = b[order.key];
                    if (x > y) return -1;
                    else if (x < y) return 1;
                    return 0;
                });
            }
            return state.units;
        }
    },
}
